window.addEventListener('load', function () {
    const canvi = document.querySelectorAll('.snowfall-animation-effect-canvas');
    for (let canvas of canvi) {
        // Get the canvas element and its context
        const ctx = canvas.getContext('2d');

        // Set canvas dimensions to full screen
        setCanvasSize();

        // Function to generate random integer within a range
        function randomIntFromRange(min, max) {
            return Math.floor(Math.random() * (max - min + 1) + min);
        }

        // Snowflake object
        function Snowflake(x, y, radius, color) {
            this.x = x;
            this.y = y;
            this.radius = radius;
            this.color = color;
            this.velocity = {
                x: randomIntFromRange(-2, 2),
                y: randomIntFromRange(1, 3)
            };
        }

        // Update snowflake position
        Snowflake.prototype.update = function () {
            this.x += this.velocity.x;
            this.y += this.velocity.y;

            // Reset snowflake position if it goes off screen
            if (this.y > canvas.height) {
                this.x = randomIntFromRange(0, canvas.width);
                this.y = randomIntFromRange(-50, 0);
            }

            this.draw();
        };

        // Draw snowflake
        Snowflake.prototype.draw = function () {
            ctx.beginPath();
            ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false);
            ctx.fillStyle = this.color;
            ctx.fill();
            ctx.closePath();
        };

        // Array to store snowflakes
        let snowflakes = [];

        // Create snowflakes
        function init() {
            for ( let i = 0; i < 100; i++ ) {
                const radius = randomIntFromRange(1, 4);
                const x = randomIntFromRange(0, canvas.width);
                const y = randomIntFromRange(0, canvas.height);
                const color = 'white';
                snowflakes.push(new Snowflake(x, y, radius, color));
            }
        }

        // Animation loop
        function animate() {
            requestAnimationFrame(animate);
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            snowflakes.forEach(snowflake => {
                snowflake.update();
            });
        }

        // Run
        init();
        animate();

        // Resize canvas when window is resized
        window.addEventListener('resize', resizeCanvas);

        function setCanvasSize() {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        }

        function resizeCanvas() {
            const oldWidth = canvas.width;
            const oldHeight = canvas.height;
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
            // Scale snowflake positions and sizes based on the new canvas size
            for (let snowflake of snowflakes) {
                snowflake.x = (snowflake.x / oldWidth) * canvas.width;
                snowflake.y = (snowflake.y / oldHeight) * canvas.height;
                snowflake.width = (snowflake.width / oldWidth) * canvas.width;
                snowflake.height = snowflake.width; // Maintain aspect ratio
            }
        }
    }
});